module.exports = __webpack_public_path__ + "static/projekty-opakowan-akcesoriow-rowerowych-3b3ed3577c09c2c07f9495a529f32a6f.jpg";